import { Col, Flex, Typography } from "antd";
import { ColumnType } from "antd/es/table";

import {
  BID_STATUSES,
  getEnumKeys,
  BidGridDto,
  REVERSE_ORDER_MAP,
  CONTRACT_CURRENCY_ENUM,
  NETWORK_TEXT,
} from "interfaces";
import { Status, TxButton } from "ui";
import {
  dateFormat,
  EXPLORER_LINK_TYPE,
  formatBalance,
  getBlockchainExplorerLink,
  getFilterIcon,
  getSortIcon,
} from "utils";
import { BidList } from "stores/BidList";
import { BidListWithBalance } from "stores/BidListWithBalance";

export const getColumns = (bids: BidList): Array<ColumnType<BidGridDto>> => {
  return [
    {
      dataIndex: "hid",
      key: "hid",
      title: "Номер заявки",
      width: 115,
    },
    {
      dataIndex: "transitWallet",
      key: "transitWallet",
      title: "Кошелек",
      width: 215,
      render: (_: any, record: BidGridDto) => {
        return record.transitWallet ? (
          <TxButton
            text={record.transitWallet}
            href={getBlockchainExplorerLink(record.network, record.transitWallet, EXPLORER_LINK_TYPE.address)}
            showCopyBtn
            isWalletAddress
          />
        ) : null;
      },
    },
    {
      dataIndex: "tokenBalance",
      key: "tokenBalance",
      title: "Баланс Токен",
      width: 160,
      align: "right",
      sorter: { multiple: 1 },
      sortOrder: bids.sorters?.tokenBalance ? REVERSE_ORDER_MAP[bids.sorters?.tokenBalance] : undefined,
      sortIcon: getSortIcon,
      render: (_: any, record: BidGridDto) => {
        return <span>{formatBalance(record.tokenBalance ?? 0, record.currency ?? "")}</span>;
      },
    },
    {
      dataIndex: "currency",
      key: "currency",
      title: "Валюта",
      width: 90,
      filterMultiple: false,
      defaultFilteredValue: bids.queryParams["currency"],
      filtered: "currency" in bids.queryParams,
      filters: getEnumKeys(CONTRACT_CURRENCY_ENUM).map((key) => ({
        text: CONTRACT_CURRENCY_ENUM[key],
        value: key,
      })),
      filterIcon: (filtered: boolean) => getFilterIcon(filtered),
      render: (_: any, record: BidGridDto) => {
        return <span>{record.currency}</span>;
      },
    },
    {
      dataIndex: "nativeBalance",
      key: "nativeBalance",
      title: "Баланс Native",
      width: 140,
      align: "right",
      sorter: { multiple: 2 },
      sortOrder: bids.sorters?.nativeBalance ? REVERSE_ORDER_MAP[bids.sorters?.nativeBalance] : undefined,
      sortIcon: getSortIcon,
      render: (_: any, record: BidGridDto) => {
        return <span>{formatBalance(record.nativeBalance ?? 0, record.network ?? "")}</span>;
      },
    },
    {
      dataIndex: "network",
      key: "network",
      title: "Сеть",
      width: 90,
      filterMultiple: false,
      defaultFilteredValue: bids.queryParams["network"],
      filtered: "network" in bids.queryParams,
      filters: getEnumKeys(NETWORK_TEXT).map((key) => ({
        text: NETWORK_TEXT[key],
        value: key,
      })),
      filterIcon: (filtered: boolean) => getFilterIcon(filtered),
      render: (_: any, record: BidGridDto) => {
        return record.network ? <span>{NETWORK_TEXT[record.network]}</span> : "";
      },
    },
    {
      dataIndex: "statusDate",
      key: "statuses",
      title: "Статус",
      sorter: { multiple: 3 },
      sortOrder: bids.sorters?.statusDate ? REVERSE_ORDER_MAP[bids.sorters?.statusDate] : undefined,
      sortIcon: getSortIcon,
      width: 220,
      align: "left",
      filterMultiple: true,
      defaultFilteredValue: bids.queryParams["statuses"],
      filtered: "statuses" in bids.queryParams,
      filters: getEnumKeys(BID_STATUSES.texts).map((key) => ({
        text: BID_STATUSES.texts[key],
        value: key,
      })),
      filterIcon: (filtered: boolean) => getFilterIcon(filtered),
      render: (_: any, record: BidGridDto) => {
        return (
          <Flex vertical>
            <Col>
              <Status color={BID_STATUSES.colors[record.status]} children={BID_STATUSES.texts[record.status]} />
            </Col>
            <Typography.Text type="secondary">{dateFormat(record.statusDate, true)}</Typography.Text>
          </Flex>
        );
      },
    },
  ].filter((c) => !!c) as Array<ColumnType<BidGridDto>>;
};
